const WASTE_METHOD_MAP = {
  "Aluminum Cans": ["Recycled", "Landfilled", "Combusted"],
  "Aluminum Ingot": ["Recycled", "Landfilled", "Combusted"],
  "Steel Cans": ["Recycled", "Landfilled", "Combusted"],
  "Copper Wire": ["Recycled", "Landfilled", "Combusted"],
  "Glass": ["Recycled", "Landfilled", "Combusted"],
  "HDPE": ["Recycled", "Landfilled", "Combusted"],
  "LDPE": ["Landfilled", "Combusted"],
  "PET": ["Recycled", "Landfilled", "Combusted"],
  "LLDPE": ["Landfilled", "Combusted"],
  "PP": ["Recycled", "Landfilled", "Combusted"],
  "PS": ["Landfilled", "Combusted"],
  "PVC": ["Landfilled", "Combusted"],
  "PLA": ["Landfilled", "Combusted", "Composted"],
  "Corrugated Containers": ["Recycled", "Landfilled", "Combusted"],
  "Magazines/Third-class mail": ["Recycled", "Landfilled", "Combusted"],
  "Newspaper": ["Recycled", "Landfilled", "Combusted"],
  "Office Paper": ["Recycled", "Landfilled", "Combusted"],
  "Phonebooks": ["Recycled", "Landfilled", "Combusted"],
  "Textbooks": ["Recycled", "Landfilled", "Combusted"],
  "Dimensional Lumber": ["Landfilled", "Combusted"],
  "Medium-density Fiberboard": ["Landfilled", "Combusted"],
  "Food Waste (non-meat)": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)", "Anaerobically Digested (Wet  Digestate with Curing)"],
  "Food Waste (meat only)": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)", "Anaerobically Digested (Wet  Digestate with Curing)"],
  "Beef": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)", "Anaerobically Digested (Wet  Digestate with Curing)"],
  "Poultry": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)", "Anaerobically Digested (Wet  Digestate with Curing)"],
  "Grains": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)", "Anaerobically Digested (Wet  Digestate with Curing)"],
  "Bread": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)", "Anaerobically Digested (Wet  Digestate with Curing)"],
  "Fruits and Vegetables": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)", "Anaerobically Digested (Wet  Digestate with Curing)"],
  "Dairy Products": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)", "Anaerobically Digested (Wet  Digestate with Curing)"],
  "Yard Trimmings": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)"],
  "Grass": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)"],
  "Leaves": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)"],
  "Branches": ["Landfilled", "Combusted", "Composted", "Anaerobically Digested (Dry Digestate with Curing)"],
  "Mixed Paper (general)": ["Recycled", "Landfilled", "Combusted"],
  "Mixed Paper (primarily residential)": ["Recycled", "Landfilled", "Combusted"],
  "Mixed Paper (primarily from offices)": ["Recycled", "Landfilled", "Combusted"],
  "Mixed Metals": ["Recycled", "Landfilled", "Combusted"],
  "Mixed Plastics": ["Recycled", "Landfilled", "Combusted"],
  "Mixed Recyclables": ["Recycled", "Landfilled", "Combusted"],
  "Mixed Organics": ["Landfilled", "Combusted", "Composted"],
  "Mixed MSW": ["Landfilled", "Combusted"],
  "Carpet": ["Landfilled", "Combusted"],
  "Desktop CPUs": ["Recycled", "Landfilled", "Combusted"],
  "Portable Electronic Devices": ["Recycled", "Landfilled", "Combusted"],
  "Flat-panel Displays": ["Recycled", "Landfilled", "Combusted"],
  "CRT Displays": ["Landfilled", "Combusted"],
  "Electronic Peripherals": ["Recycled", "Landfilled", "Combusted"],
  "Hard-copy Devices": ["Recycled", "Landfilled", "Combusted"],
  "Mixed Electronics": ["Recycled", "Landfilled", "Combusted"],
  "Clay Bricks": ["Landfilled"],
  "Concrete": ["Recycled", "Landfilled"],
  "Fly Ash": ["Recycled", "Landfilled"],
  "Tires": ["Recycled", "Landfilled", "Combusted"],
  "Asphalt Concrete": ["Recycled", "Landfilled"],
  "Asphalt Shingles": ["Recycled", "Landfilled", "Combusted"],
  "Drywall": ["Landfilled"],
  "Fiberglass Insulation": ["Recycled", "Landfilled"],
  "Structural Steel": ["Recycled", "Landfilled"],
  "Vinyl Flooring": ["Landfilled", "Combusted"],
  "Wood Flooring": ["Landfilled", "Combusted"]
};

export default WASTE_METHOD_MAP;
